import { useMutation } from "@tanstack/react-query";
import { generatePath, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { ErrorResponse, startIntake } from "~/patients/api";
import { ROUTES } from "~/patients/router";

export const useStartIntake = () => {
  const navigate = useNavigate();

  const { mutate: startIntakeMutation, isPending } = useMutation({
    mutationFn: startIntake,
    onSuccess: ({ id }) => {
      navigate(
        generatePath(ROUTES.intake, {
          id,
        }),
      );
    },
    onError: (error: ErrorResponse) => {
      const errorMessage =
        error.response?.status === 400
          ? "Previous sections must be completed before starting this section."
          : "An error occurred while starting this section. If the issue persists, please refresh the page.";

      toast.error(errorMessage);
    },
  });

  return { startIntakeMutation, isPending };
};
